import ca from './ca';
import en from './en';
import es, { es_alt_setup_fee } from './es';

export const LANGUAGES = {
  spanish: 'es',
  english: 'en',
  catalan: 'ca',
};

export const REGISTRIES = {
  default: 'default',
  unbranded: 'unbranded',
  caixabank: 'caixabank',
  iberia: 'iberia',
};

export const dictionaryList = {
  [LANGUAGES.english]: {
    [REGISTRIES.default]: en,
    [REGISTRIES.unbranded]: en,
    [REGISTRIES.caixabank]: en,
    [REGISTRIES.iberia]: en,
  },
  [LANGUAGES.spanish]: {
    [REGISTRIES.default]: es,
    [REGISTRIES.unbranded]: es,
    [REGISTRIES.caixabank]: es,
    [REGISTRIES.iberia]: es,
    // [REGISTRIES.unbranded]: { ...es, ...es_unbranded }, //EXAMPLE HOW TO MAKE A CUSTOM DICTIONARY
    alt_setup_fee: { ...es, ...es_alt_setup_fee },
  },
  [LANGUAGES.catalan]: {
    [REGISTRIES.default]: ca,
    [REGISTRIES.unbranded]: ca,
    [REGISTRIES.caixabank]: ca,
    [REGISTRIES.iberia]: ca,
  },
};

export const defaultLang = LANGUAGES.spanish;
export const defaultRegion = 'es';
export const defaultRegistry = REGISTRIES.default;

// Dictionaries health check helper (detects missing keys from translations)
// getDictionaryMissingKeys();
